// 法国
import frLocale from 'element-ui/lib/locale/lang/fr'
const fr = {
login:{
buttoo:{
    add:'add'
}
},
dialog:{
buttton:{
    close:'Fermer'
},
ReportError:{
      next:'Next',
 h1:'Report Errors allows users to communicate with us to solve any data issues and improve data quality.',
 li1:'If you find any data problems or have a question about this data',
 li2:'If you want to contribute company information to improve this data',
 li3:'If you choose not to disclose your own company information that you might consider private',
 li4:'If you have any constructive suggestions for us to improve services',
 h2:"All comments submitted are subject to data verification. Users must complete your own user profile as our representative may contact you for authentication and verification of your company any rights to represent your company."
},
},
Home:{
    Applications:'Applications',
  SearchCompanies:'Search Companies',
  SearchTrade:'Search Trade',
  SearchRisks:'Search Risks',
  SearchCountries:'Search Countries',
  SearchNews:'Search News',
  SearchLeads:'Search Leads',
 selectCountry:'Sélectionner un pays',
 inputCompany:"Entrez le nom de l'entreprise",
 keWord:'Mot-clé',
 firstWord:"Texte (mots de gauche)",
 searchCompanyNum:"Rechercher plus de 500 millions d'entreprises dans plus de 200 pays et territoires",
 search:'Recherche',
 homeSeachTitle:'Pleins feux sur les entreprises',
 homeTitleDetail:"CSI, cabinet de recherche et d'informatique axé sur les données, est spécialisé dans le crédit, le risque et le big data. Il propose des outils numériques aux investisseurs et aux professionnels du monde entier, exploitant des analyses et des algorithmes avancés pour fournir des informations visuelles rapides et faciliter la prise de décision.",
 phoneTitleDetail:"Pour rechercher, consulter et obtenir rapidement des informations sur les entreprises, vous pouvez également utiliser l'application CSI sur votre téléphone.",
  IndustryAnalysis :'Industry Analysis',
BusinessAnalytics :'Business Analytics',
ImportExportData :'Import-Export Data',
CompanyNews :'Company News',
Sanctions :'Sanctions',
SearchLeads:"Search Leads",
BusinessIntelligence :'Business Intelligence',
CompanyIdentityVerification :'Company Identity Verification',
KYCSolutions :'KYC Solutions',
OwnershipPenetration :'Ownership Penetration',
CompanyFinancialAnalysis:'Company Financial Analysis',
CreditRatings :'Credit Ratings',
CreditReports :'Credit Reports',
ESGRatings :'ESG Ratings',
VendorScreening :'Vendor Screening ',
MarketResearch:'Market Research ' 
},
IndustryStatistics:{
    SubjectCompany:"Entreprise concernée",
    Country:"Pays",
    Compare:"Comparer",
    Industry:"Secteur d'activité",
    CompanyType:"Type d'entreprise",
    CompanySize:"Taille de l'entreprise",
    CompanyStatus:"Statut de l'entreprise",
    YearsinBusiness:"Nombre d'années d'activité",
    CompanyRating:"Évaluation de l'entreprise"
},
ListofResults:{
  SelectCountry:'Select Country',
  ClearAll:'Clear All',
  SelectIndustry:'Select Industry',
  ListedCompany:'Listed Company',
  YearsinBusiness:'Years in Business',
   Sharethisinformation:'Share this information',
  Pleaseaddress:'Please enter one or more email address',
  Example:'Example',
  message:'message',
  pleaseleaveamessage:'please leave a message',
  Include:'',
  thisaddress:'this company name,ID,address',
  CSIwebsite:'CSI website',
  Update:'Update',
  Iftheavailable:'If the available online data is insufficient or outdated, you can click the “Update” button to request an instant update for a fresh investigated business credit report from our local networking investigators or credit reporting agencies. The cost for this update is 1 credit per company. The update report typically takes between 24 and 72 hours to be delivered.',
  Abusinesscredit :'A business credit report provides detailed information about the subject company’s identification data, registry records, shareholding structure, company history, management description, related companies, actual operations, trade references, financial data and analysis, official public information such as litigation records and sanctions, and credit analysis and assessment.',
  Searchcompanies:'Search more emails on other companies',
  Rowsperpage:'Rows per page'

},
Toolbar:{
    Filter:"Filtrer",
    Select:"Sélectionner",
    Edit:"Modifier",
    Sortby:"Trier par",
    Collect:"Collecter",
    Saved:"Enregistré",
    Compare:"Comparer",
    Export:"Exporter",
    Download:"Télécharger",
    Update:"Mettre à jour",
    Reporterror:"Signaler une erreur",
    Share:"Partager",
          ascending:'ascending',
    descending:'descending',
    Customfolder:'Custom folder'
},
AiZaba:{
whatareyousearchingfor:'what are you searching for',
CreditAnalyst:'Credit Analyst',
Assesses:"Assesses a company'screditworthiness,identifiesfinancial risks,ensuring secure transactionsthrough data analysis andcredit ratings.",
LegalAdvisor:"Legal Advisor",
Provides:'Provides compliance guidance,reviews contracts,andassesseslegarisks to ensure businessoperations align with lawsand avoid disputes.',
BizConsultant:'Biz Consultant',
Optimizes:'Optimizes supply chains,identifiesbuyers, andboosts sales by analyzingmarket trends and offeringtailored strategies to improve efficiency',
EconomicAnalyst:'Economic Analyst',
Analyzes:"Analyzes industry and regional economic trendshelping businesses makeinformed decisions, and staycompetitive."
},
ContentTabs:{
    Background:"Contexte",
    BusinessActivities:"Activités commerciales",
    Performance:"Performance",
    Publications:"Publications",
    CreditOpinion:"Avis de crédit",
    MarketAnalysis:"Analyse de marché",
    Snapshot:"Aperçu",
    Profile:"Profil",
    Ownership:"Actionnariat",
    RelatedCompanies:"Sociétés liées",
    Management:"Direction",
    Operations:"Opérations",
    Locations:"Implantations",
    Industry:"Secteur",
    ImportExport:"Importation et exportation",
    SupplyChain:"Chaîne d'approvisionnement",
    FinancialHighlights:"Points financiers marquants",
    RatioAnalysis:"Analyse des ratios",
    IndustryNorm:"Norme du secteur",
    News:"Actualités",
    Sanctions:"Sanctions",
    IndustryStatistics:"Statistiques du secteur",
    RatingAnalysis:"Analyse des notations",
    CompetitiveAnalysis:"Analyse concurrentielle"
},
navigationBar:{
Notifications:'Notifications',//通知
MarkasRead:'Marquer comme lu',//标记已读
Viewall:'Tout afficher',//查看全部
SilverSubscriber:'Abonné Silver',//银级用户
Silversubscriberdate:"Date d'expiration de l'abonnement Silver",//银级到期日
GoldSubscriber:'Abonné Gold',//金级用户
Goldsubscriptiondate:"Date d'expiration de l'abonnement Gold",//金级到期日
AvailableCredits:'Crédits disponibles',//可用积分
AddCredits:'Ajouter des crédits',//购买积分
IndivdualAccount:'Compte individuel', //个人账号
GroupAccount:'Compte de groupe' //集团账号
},
Snapshot:{
    CompanyDQIdesc:"The Data Quality Index (DQI) employs algorithms to assess different aspects of data, including completeness, validity, reliability of sources, consistency, timeliness, and bilingual support.The index is designed to assess the quality of data on a scale of 1 to 100, with higher scores indicating superior data quality. Algorithms can analyze data based on predefined rules or criteria, enabling objective and standardized measurements.Our Data Quality Index (DQI) serves as a reliable indicator, allowing users to quantitatively assess data quality. This enables data-driven decision-making and enhances the overall value and utility of the data.",
  CountryDQIdesc:"The Data Quality Index (DQI) assesses the reliability, accuracy, and accessibility of data across countries, reflecting differences in digital infrastructure, governance, and transparency. Developed nations typically rank higher due to strong data systems, open policies, and advanced technology, while developing economies often struggle with gaps in infrastructure, regulation, or data-sharing practices. Key factors include government transparency, data protection laws, and technological adoption. A high DQI enables better policymaking and business decisions, while a low score highlights areas needing investment.",
  CompanyDQI:"DQI de l'entreprise",//公司数据质量指数 DQI
  CountryDQI:'Pays DQI',//国家数据质量指数 DQI
  Address:'Adresse',//地址
  CountyCity:'Comté/Ville',//县/市
  ProvinceState:'Province/État',//省/州
  CountryRegion:'Pays/Région',//国家/地区
  ZipCode:'Code postal',//邮政编码
  Website:'Site web',//网站
  Email:'E-mail',//电邮
  Tel:'Tél.',//电话
  LastUpdate:'Dernière mise à jour',//最近更新
  DataSource:'Source des données',//数据来源
  LegalStatus:'Statut juridique',//法定状况
  CoID:"ID de l'entreprise",//公司ID
  CompanyType:"Type d'entreprise",//公司类型
  RegistrationDate:"Date d'enregistrement",//注册日期
  RegistrationStatus:"Statut d'enregistrement",//注册状态
  Listed:'Cotée',//上市信息
  CurrentOpperations:'Opérations actuelles',//经营状况
  IndustryCode:"Secteur d'activité",//行业代码
  BusinessActivities:'Activités commerciales',//主营业务
  NoofEmployees:"Nombre d'employés",//员工数量
  NoofShareholders:"Nombre d'actionnaires",//股东数量
  Management:'Direction',//管理状况
  Performance:'Performance',//业绩表现
  Revenue:"Chiffre d'affaires",//收入
  Assets:'Actifs',//资产
  ProfitLoss:'Bénéfice/Perte',//利润
  Growth:'Croissance',//公司增长
  Competitiveness:'Compétitivité',//竞争力
  CreditOpinion:'Avis de crédit',//信用状况
  CreditRating:'Notation de crédit',//信用评级
  CreditScore:'Score de crédit',//信用评分
  ESGRating:'Notation ESG',//ESG 评级
  Solvency:'Solvabilité',//偿还能力
  Sanctions:'Sanctions',//全球制裁
},
Profile:{
  CompanyProfile:"Profil de l'entreprise",//基本资料
  CompanyName:"Nom de l'entreprise",//公司名称
  NativeName:"Nom d'origine",//当地名称
  CompanyID:"Numéro d'identification de l'entreprise",//公司 ID
  VATNumber:'Numéro de TVA',//VAT号
  StockCode:'Code boursier',//股票代码
  Listed:'Cotation',//上市日期
  RegistrationDate:"Date d'immatriculation",//注册日期
  LegalForm:'Forme juridique',//公司性质
  CompanyType:"Type d'entreprise",//公司类型
  LegalStatus:'Statut juridique',//注册状态
  Jurisdiction:'Juridiction',//司法管辖区
  RegisteredAddress:'Adresse enregistrée',//注册地址
  ProvinceState:'Province/État',//省/州
  CountryRegion:'Pays/Région',//国家/地区
  ZipCode:'Code postal',//邮政编码
  OperatingAddress:"Adresse d'exploitation",//经营地址
  LastUpdate:'Dernière mise à jour',//最近更新
  DataSource:'Source des données',//数据来源
  History:'Historique',//历史记录
    RegisteredCapital:'Registered Capital',
  PaidinCapital:'Paid-in Capital',
       CountyCity:'County/City'
},
Ownership:{
 UltimateBeneficiary:'Bénéficiaire final',//最终受益人
  InvolvingIndividuals:'Particuliers',//涉及自然人股东
  InvolvingEnterprises:'Entreprises',//涉及法人股东
  ShareholderLevel:"Niveau d'actionnaire",//股东层级x
  Name:'Nom',//名称
  Country:'Pays',//国家/地区
  Location:'Localisation',//地点
  Type:'Type',//类型
  Shares:'Actions',//股份
  Relation:'Lien',//关系
    Individuals :'Individuals',//关系
        PartiesInvolved:'Parties Involved',
  RelatedCompany:'Related Company',
  CompanyShareholders:'Company Shareholders',
  NGOShareholders:'NGO Shareholders',
  NaturalPersonShareholder:'Natural Person Shareholder',
  SubjectInvestments:"Subject's Investments"
},
RelatedCompanies:{
 Total:'Total',//相关公司总计
  Entities:'Entités',//法人实体
  Countries:'Pays',//国家/地区
  Branches:'Succursales',//分支机构
  RelatedComp:'Sociétés liées',//关联公司
  Name:'Nom',//名称
  Country:'Pays',//国家/地区
  Location:'Localisation',//地点
  Type:'Type',//类型
  Relation:'Relation',//关系
  BranchOffices:'Branch Offices',
  Individuals:'Individuals',
},
Management:{
  Total:'Management',//管理层
  ContactInfo:'Coordonnées',//联系人信息
  Countries:'Pays',//国家/地区

  Name:'Nom',//名称
  Position:'Poste',//职位
  Department:'Service',//部门
  Country:'Pays',//国家/地区
  ShareholderNot:'Actionnaire ou non',//是否股东
  Relation:'Relations',//关系
  Verification:'Vérification',//已验证
  Searchmoreemails:"Rechercher d'autres adresses e-mail",//搜索更多电邮
  Roles:'Postes',//角色
  EducationLevel:"Niveau d'études",//教育程度
  Phone:'Téléphone',//电话
  Email:'E-mail',//电邮
  Verified:'Vérifié',//已验证
  Searchmore:"Rechercher d'autres adresses e-mail sur d'autres entreprises",//搜索更多其他公司的电邮
},
Operations:{
    Operations:'Operations',
  LineofBusiness:"Secteur d'activité",//业务范围
  BusinessTerritories:"Territoires d'activité",//业务区域
  ImportExport:'Importation et exportation',//进出口信息
  Viewtradeinfo:"Voir plus d'informations commerciales",//查看更多贸易信息
  ProductsServices:'Produits/Services',//产品/服务
  Products:'Produits',//产品
  ProductImage:'Image du produit',//产品图片
  ProductName:'Nom du produit',//产品名称
  ProductDescription:'Description du produit',//产品描述
  Details:'Détails',//详情
  Addproductinformation :'Ajouter des informations sur le produit',//添加产品信息
},
Locations:{
   Locations:"Locations",
  CoName:"Nom de l'entreprise",//业务范围
  Relationship:'Lien',//关系
  Country:'Pays',//国家/地区
  Location:'Localisation',//地点
  Address:'Adresse',//地址
  Edit:'Modifier',//编辑
  CompanyLocatiionsMap:"Emplacements de l'entreprise sur la carte",//地图中的公司位置
  Selectaddresstype:"Sélectionner le type d'adresse",//选择地址类型
  Subjectcompany:'Société concernée',//目标公司
  Subsidiary:'Filiale',//子公司
  RegisteredAddress :'Adresse du siège social',//注册地址
  OperationAddress :"Adresse de l'établissement",//运营地址
  All :'Tous',//全部
},
Industry:{
  IndustryTitle:'Intitulé du secteur',//IndustryTitle
  IndustryDescription:'Description du secteur',//IndustryDescription
  ISIC:'CITI',//ISIC
  ISICDescription:'Description CITI',//ISICDescription
  NACE:'NACE',//NACEDescription
  NACEDescription:'Description NACE',//NACEDescription
  NAICS:'NAICS',//NAICS
  NAICSDescription:'Description SCIAN',//NAICSDescription
  CSIC:'CSIC',//CSIC, 
  CSICDescription:'Description CSIC',//CSICDescription
  AAAIC:'AAAIC',//AAAIC
  AAAICDescription :'Description AAACIC',//AAAICDescription
  GICS :'GICS',//GICS
  GICSDescriptio :'Description GICS',//GICS 描述
},
ImportExport:{
  TotalImportAmount:'Montant total des importations',//进口总额
  TopImportCountry:"Principaux pays d'importation",//最大进口国家/地区
  TopImportProduct:"Exportations totales",//最大进口产品
  TotalExport:'Exportations totales',//出口总额
  TopExportCountry:"Principaux pays d'exportation",//最大出口国家/地区
  TopExportProduct:"Principaux produits d'exportation",//最大出口产品
  TradeVolume:'Volume des échanges',//贸易额
  ImportShipments:"Expéditions d'importation",//进口量
  ExportShipments:"Expéditions d'exportation",//出口量
  ImportCountries:"Pays d'importation",//进口国家/地区
  ExportCountries:"Pays d'exportation",//出口国家/地区
  ImportVolume:'Volume des importations',//进口量
  ExportVolume:'Volume des exportations',//出口量
  TopSuppliers:'Principaux fournisseurs',//主要供应商
  ByNumberofShipments:"Par nombre d'expéditions",//按出货量
  TopBuyers:'Principaux acheteurs',//主要买家
  ByNumberofShipments:"Par nombre d'expéditions",//按出货量
  ImportQuantity:'Quantité importée',//进口数量
  IncreaseDecreasexRate:"Taux d'augmentation/diminution",//增/减率
  ExportQuantity:'Quantité exportée',//出口数量
  ImportsExportsRecords:"Enregistrements d'importations et d'exportations",//进出口记录
  Date:'Date',//日期
  Product:'Produit',//产品
  HSCode:'Code SH',//HS 编码
  BuyerName:"Nom de l'acheteur",//买家名称
  Destination:'Destination',//目的地
  SupplierName:'Nom du fournisseur',//供应商名称
  Origin:'Origine',//原产地
  Amount:'Montant',//金额
  Details:'Détails',//详情
},
 FinancialHighlight:{
    ProfitabilityRatios:'Profitability Ratios',
  OperatingRatios:'Operating Ratios',
  StructuralRatios:'Structural Ratios',
ProductivityRatios:'Productivity Ratios',
GrowthRatios:'Growth Ratios',
  Revenue:"Chiffre d'affaires",//收入
  Profit:'Bénéfice',//利润
  Growth:'Croissance',//增长
  Liquidity:'Trésorerie',//现金流状况
  FinancialStructure:'Structure financière',//融资结构
  CreditOpinion:'Avis de crédit',//信用评估
  RiskIndicator :'Indicateur de risque',//风险指标
  Solvencyindex:'Indice de solvabilité',//偿还指数
  Year:'Année',//年份
  Change:'Variation',//变化
  FinancialHighlights:'Données financières des sociétés liées',//关联公司财务数据
  FinancialHighlightsTitle:'Points clés financiers des sociétés liées',//关联公司财务摘要
  CompanyName:"Nom de l'entreprise",//公司名称
  CompanyID:"Numéro d'identification de l'entreprise",//公司ID
  Country:'Pays',//国家/地区
  CompanyStatus:"Statut de l'entreprise",//公司状态
  Relations:'Relations',//关系
  RatioAnalysis:'Analyse des ratios des sociétés liées' //关联公司比率分析
},
IndustryNorms:{
    IndustryStatistics:"Statistiques sectorielles",
    ofcompaniesintheIndustry:"Nombre d'entreprises du secteur",
    oflistedCompaniesintheIndustry:"Nombre d'entreprises cotées",
    oflargecompaniesintheIndustry:"Nombre de grandes entreprises du secteur",
    ofSMEsintheIndustry:"Nombre de PME du secteur",
    ofcompaniesinsample:"Nombre d'entreprises de l'échantillon",
    ofcompaniesinloss:"Nombre d'entreprises déficitaires",
    Observations:"Observations",
    AverageValue:"Valeur moyenne",
    MedianValue:"Valeur médiane",
    MaximumValue10:"Valeur maximale : 10 %",
    MinimumValue10:"Valeur minimale : 10 %",
    SubjectCompany:"Entreprise concernée",
    YearsinBusiness:"Nombre d'années d'activité",
    TotalAssets:"Actif total",
    TotalEquity:"Capitaux propres",
    Revenue:"Chiffre d'affaires",
    NetEarning:"Bénéfice net",
    Returnonassets:"Rendement des actifs",
    Performance:"Performance",
    ProfitabilityRatios:"Ratios de rentabilité",
    Returnonequity:"Rendement des capitaux propres",
    Returnonassets:"Rendement des actifs",
    Grossmargin:"Marge brute",
    OperatingRatios:"Ratios d'exploitation",
    Stockturnover:"Rotation des stocks",
    Accountsreceivableturnover:"Rotation des créances clients",
    Assetsturnover:"Rotation des actifs",
    Totalassetturnover:"Rotation totale des actifs",
    StructuralRatios:"Ratios de structure",
    Currentratio:"Ratio de liquidité",
    Quickratio:"ratio de liquidité générale",
    Shareholdersliquidityratio:"Ratio de liquidité des actionnaires",
    GrowthRatios:"Ratios de croissance",
    Salesgrowthrate:"Taux de croissance des ventes",
    Netprofitgrowthrate:"Taux de croissance du bénéfice net",
    Totalassetsgrowthrate:"Taux de croissance de l'actif total"
},
 News:{
  Date:'Date',//日期
  Title:'Titre',//标题
  Source:'Source',//来源
  Impact:'Impact',//影响
  Searchcompanies:"Rechercher plus d'actualités sur d'autres entreprises",//国家/地区
},
 Sanctions:{
  Potentialcompliance:'Risques potentiels de non-conformité détectés',//检测到潜在合规风险
  SeachbuttonNo:"Aucun élément préjudiciable n'a été détecté concernant cette entreprise.",//未检测到任何与该公司相关的不良记录
  SeachbuttonYes:"Pour rechercher d'autres dossiers de sanctions, cliquez sur le bouton « Rechercher des sanctions ».",//要搜索更多制裁记录，请点击“搜索制裁”按钮。
  SearchSanctions:'Rechercher des sanctions',//搜索制裁
  ViewDetails:'Voir les détails',//查看详情
  Sanctions:'Sanctions',//制裁
  Potentialcompliancerisks:'Risques potentiels de non-conformité',//潜在合规风险
  IDInfo:"Informations sur l'ID",//ID 信息
  IDType:"Type d'ID",//ID 类型
  IDDescription:"Description de l'ID",//ID 描述
  SanctionList:'Liste des sanctions',//制裁名单
  SanctionListInvolved:'Liste des sanctions concernées',//涉及的制裁名单
  StartDate:'Date de début',//生效日期
  EndDate:'Date de fin',//结束日期
  SourceList:'Liste des sources',//来源名单
  SourceName:'Nom de la source',//来源名称
  ProfileNotes:'Notes de profil',//主体资料
  Link:'Lien',//链接
},
CreditOpinion:{
    CreditAssessment:"Évaluation de crédit",
    CreditAssessmentfromtheRelatedCompanies:"Évaluation de crédit des sociétés liées",
    Year:"Année",
    CreditRating:"Notation de crédit",
    LocalCreditScore:"Score de crédit local",
    ProbabilityofDefault:"Probabilité de défaut",
    SolvencyIndex:"Indice de solvabilité",
    CreditLine:"Ligne de crédit",
    RiskIndicator:"Indicateur de risque",
    RelatedCreditAssessment:"Évaluation de crédit liée",
    CompanyName:"Nom de l'entreprise",
    CompanyID:"Identifiant de l'entreprise",
    Country:"Pays",
    CompanyStatus:"Statut de l'entreprise",
    Relations:"Relations"
},
RatingAnalysis:{
    IndustyAnalysis:"Analyse sectorielle",
    GeographicAnalysis:"Analyse géographique",
    CompanyTypeAnalysis:"Analyse du type d'entreprise",
    BiusinessScaleAnalysis:"Analyse de l'échelle d'activité",
    HistoryAnalysis:"Analyse historique",
    NormalDistribution:"Distribution normale",
    SubjectCompany:"Entreprise concernée",
    Probabilityofthesubjectratinginitsindustry:"Probabilité d'obtention d'une note dans son secteur",
    Maximum:"Maximum 10 %",
    Mean:"Moyenne",
    Average:"Moyenne",
    Minimum:"Minimum 10 %",
    RatingDistribution:"Distribution des notes",
    Revenue:"Chiffre d'affaires",
    Earning:"Bénéfices",
    TotalAssets:"Actifs totaux",
    Subjectratinginitsindustrybyfinancialindicators:"Note du sujet dans son secteur selon les indicateurs financiers",
    Best:"Meilleur",
    Worst:"Pire",
    Rankingofsubject:"Classement du sujet dans son secteur",
    Industy:"Secteur",
    Percentilerank:"Classement en percentile : % d'entreprises ayant obtenu une note égale ou inférieure à celle du sujet",
    Historicaldevelopmentofsubject:"Évolution historique de la note du sujet dans son secteur",
    IndustryAverage:"Moyenne du secteur",
    SubjectRatingChanges:"Évolution des notes du sujet"
},
CompetitiveAnalysis:{
    MarketPosition:"Position sur le marché",
    Revenus:"Chiffre d'affaires",
    NetEarnings:"Bénéfice net",
    NetAssets:"Actif net",
    TotalAssets:"Actif total",
    Employees:"Employés",
    Mean:"Moyenne",
    Average:"Moyenne",
    Maximum:"Maximum (10 %)",
    Worst:"Pire (10 %)",
    Subjectcompany:"Entreprise concernée",
    PerformanceComparison:"Comparaison des performances",
    ProfitabilityRatios:"Ratios de rentabilité",
    Grossmargin:"Marge brute",
    Returnonassets:"Rendement des actifs",
    Returnonequity:"Rendement des capitaux propres",
    Average:"Moyenne",
    OperatingRatios:"Ratios d'exploitation",
    Stockturnover:"Rotation des stocks",
    Assetsturnover:"Rotation des actifs",
    Collectionperiod:"Période de collecte",
    GrowthRatios:"Ratios de croissance",
    Totalassetsgrowthrate:"Taux de croissance du total des actifs",
    Salesgrowthrate:"Taux de croissance des ventes",
    Netprofitgrowthrate:"Taux de croissance du bénéfice net",
    StructuralRatios:"Ratios de structure",
    Debtratio:"Ratio d'endettement",
    Quickratio:"ratio de liquidité générale",
    Currentratio:"Ratio de liquidité"
},
AccountCenterMenu:{
SearchinSettings:"Rechercher dans les Paramètres",//在“设置”中搜索
Account:"Compte",//账户
MyAccount :"Mon compte",//我的账户
ContactInfo:"Coordonnées",//联系信息
AccountSecurity:"Sécurité du compte",//账户安全
OrganizationalManagement:"Gestion organisationnelle",//组织管理
UserGroup:"Groupe d'utilisateurs",//用户组
User:"Utilisateur",//用户
Role:"Rôle",//角色
MyDatabase:"Mon utilisation",//我的数据库
MyUsage:"Mon utilisation",//我的使用情况
CompaniesViewed:"Entreprises consultées",//查看过的公司
ReportsDownloaded:"Rapports téléchargés",//下载的报告
ReportUpdatesOrdered:"Mises à jour de rapports commandées",//订购的报告更新
BillingandPayment:"Facturation et paiement",//账单和付款
BillRecords:"Enregistrements de factures",//账单记录
PaymentRecords:"Enregistrements de paiement",//付款记录
CreditDeductions:"Déductions de crédit",//信用扣款
InvoicesDownloaded:"Factures téléchargées",//下载的发票
UserSettings:"Paramètres utilisateur",//用户设置
Messages:"Messages",//消息
Notifications:"Notifications",//通知
HelpCenter:"Centre d'aide",//帮助中心
FAQ:"FAQ",//常见问题
Privacy:"Conditions",//隐私
Terms:"Conditions",//条款
ReportIssues:"Guide de l'utilisateur",//报告问题
UserGuide:"Guide de l'utilisateur",//用户指南
AboutCSI:"À propos de CSI"//关于CSI


},
MyAccount:{
Logintime:'登录时间',//登录时间
SignOut:'退出',//退出
DeleteAccount:'删除账户',//删除账户
AccountID:'账户ID',//账户ID
Enteranewaddress:'输入新的电邮',//输入新的电邮
EnterVerificationCode:'输入验证码',//输入验证码
SendverificationCode:'发送验证码',//发送验证码
Password:'密码',//密码
Originalpassword:'原始密码',//原始密码
Newpassword:'新密码',//新密码
Confirmnewpassword:'确认新密码',//确认新密码
AccountOwnership:'账户所有权',//账户所有权
IndividualAccount:'个人账户',//个人账户
GroupAccount:'集团账户',//集团账户
Organizationname:'机构名称',//机构名称
CountryRegion:'国家/地区',//国家/地区
Address:'地址',//地址
City:'城市',//城市
ZipCode:'邮政编码',//邮政编码
FirstName:'名字',//名字
LastName:'姓氏',//姓氏
PhoneNumber:'电话号码',//电话号码
Email:'电邮',//更改
Change:'更改',//更改
Save:'保存',//保存
Cancel:'取消',//取消
LastLogin:'Last Login',//Last Login
RecentLogin:'登录尝试次数',//登录尝试次数
AverageLoginTime:'平均登录时间',//平均登录时间
TotalLoginAttempts:'登录尝试次数',//登录尝试次数

},
ShippingOrderDetails:{
    Date:"Date",
    MasterBillofLading:"Connaissement principal",
    Source:"Source",
    BillNo:"N° de facture",
    ImporterBuyer:"Importateur / Acheteur",
    ExporterSeller:"Exportateur / Vendeur",
    Name:"Nom",
    Address:"Adresse",
    Country:"Pays",
    Contact:"Contact",
    Email:"E-mail",
    CargoInfo:"Informations sur le fret",
    HSCode:"Code SH",
    Quantity:"Quantité",
    WeightUnit:"Unité de poids",
    ProductDescription:"Description du produit",
    Amount:"Montant",
    QuantityUnit:"Unité de quantité",
    Weight:"Poids",
    HSDescription:"Description SH",
    Incoterms:"Incoterms",
    ShippingInfo:"Informations d'expédition",
    Vessel:"Navire",
    Consignee:"Destinataire",
    MeansofTransport:"Moyen de transport",
    CountryofOrigin:"Pays d'origine",
    Voyage:"Voyage",
    Notifier:"Notificateur",
    CountryofDestnation:"Pays de destination",
    AddressofOrigin:"Adresse d'origine",
    Shipper:"Expéditeur",
    AddressofDestnation:"Adresse de destination",
    Container:"Conteneur",
    ContainerID:"ID du conteneur",
    ContainerType:"Type de conteneur",
    ContainerDescDode:"Description du conteneur",
    ContainerSize:"Taille du conteneur"
},
ReportIssues:{
    Whattypeoferrorsyouarereporting:"Quel type d'erreurs signalez-vous ?",
    Tellusmoreaboutyourproblems:"Décrivez-nous vos problèmes.",
    Wouldyouliketoprovideascreenshotorafileregardingyourproblem:"Souhaitez-vous fournir une capture d'écran ou un fichier concernant votre problème ?",
    Fillinyourcontactinformation:"Indiquez vos coordonnées",
    FirstName:"Prénom",
    LastName:"Nom",
    PhoneNumber:"Numéro de téléphone",
    Email:"E-mail"
},
UserSettings:{
    LanguageandLocation:"Langue et localisation",
    Language:"Langue",
    Selectyourpreferedlanguage:"Sélectionnez votre langue préférée",
    Location:"Localisation",
    Selectyourlocation:"Sélectionnez votre localisation",
    NotificationSetting:"Paramètres de notification",
    EmailNotification:"Notification par e-mail",
    ServiceUpdates:"Mises à jour du service",
    CompanyNews:"Actualités de l'entreprise"
},
ContactInfo:{
    ContactInfo:"Coordonnées",
    FirstName:"Prénom",
    LastName:"Nom",
    PhoneNumber:"Numéro de téléphone",
    Email:"E-mail",
    CountryRegion:"Pays/Région",
    AddressLine:"Adresse",
    City:"Ville",
    ZipCode:"Code postal",
    Alternativecontactperson:"Autre contact",
    Setascontactperson:"Définir comme contact",
    Edit:"Modifier"
},
AccountSecurity:{
    Setupmysecurityquestions:"Configurer mes questions de sécurité",
    Pleasechooseaquestion:"Veuillez choisir une question",
    Pleaseentertheanswertothequestion:"Veuillez saisir la réponse à la question",
    SessionTimeoutAutomaticLogoutSettings:"Délai d'expiration de session : Paramètres de déconnexion automatique",
    Thesystemwillautomatically:"Le système vous déconnectera automatiquement après une période d'inactivité. Le délai d'expiration par défaut est de 5 minutes, mais vous pouvez l'ajuster selon vos besoins."
},
MyDatabase:{
    TotalNumberofCompaniesSearched:"Nombre total d'entreprises recherchées",
    TotalNumberofCompaniesCollected:"Nombre total d'entreprises collectées",
    TotalNumberofUpdateReportsOrdered:"Nombre total de rapports de mise à jour commandés",
    Date:"Date",
    UserName:"Nom d'utilisateur",
    CompanyName:"Nom de l'entreprise",
    Status:"Statut",
    UsageType:"Type d'utilisation",
    Entercompanyname:"Saisir le nom de l'entreprise",
    Download:"Télécharger"
},
OrganizationalManagement:{
    GroupName:"Nom du groupe",
    ParentGroupName:"Nom du groupe parent",
    Organization:"Organisation",
    GroupID:"ID du groupe",
    GroupStatus:"Statut du groupe",
    Operation:"Opération",
    NewlyBuilt:"Nouvellement créé",
    UserAccount:"Compte utilisateur",
    Role:"Rôle",
    AccountStatus:"Statut du compte",
    RoleName:"Nom du rôle",
    Position:"Poste",
    RoleStatus:"Statut du rôle",
    Valid:"Valide",
    Invalid:"Invalide",
    PermissionSettings:"Paramètres d'autorisation"
},
BillingandPayment:{
    TotalNumberofOrders:"Nombre total de commandes",
    TotalPaymentAmount:"Montant total du paiement",
    TotalDeductionCredits:"Total des crédits de déduction",
    Date:"Date",
    UserAccount:"Compte utilisateur",
    CompanyName:"Nom de l'entreprise",
    OrderNo:"N° de commande",
    OrderType:"Type de commande",
    OrderStatus:"Statut de la commande",
    Download:"Télécharger",
    PaymentAmount:"Montant du paiement",
    Contactus:"Nous contacter",
    DownloadInvoice:"Télécharger la facture",
    CreditsDeducted:"Crédits déduits",
    ReportOrderStatus:"Statut de la commande",
    CompanyID:"Identifiant de l'entreprise",
    CountryRegion:"Pays/Région",
    AddressLine:"Adresse",
    City:"Ville",
    ZipCode:"Code postal",
    FirstName:"Prénom",
    LastName:"Nom",
    PhoneNumber:"Numéro de téléphone",
    Email:"E-mail",
    BankAccountHolderName:"Nom du titulaire du compte bancaire",
    BeneficiaryBankName:"Nom de la banque du bénéficiaire",
    SWIFTCODE:"CODE SWIFT",
    AccountNumber:"Numéro de compte",
    BeneficiaryBankAddress:"Adresse de la banque du bénéficiaire",
    ABA:"Numéro d'acheminement (ABA)",
    IBANnumber:"Numéro IBAN"
},
JiuGuoge:{
  Country:'Country',
  Industry:'Industry',
  CoSize:'Co. Size',
  Liquidity:'Liquidity',
  NoofcoinIndustry:'No. of co. in Industry',
  IndustryRating:'Industry Rating',
  Profitability:'Profitability',
  Growth:'Growth',
  FinancialStructurt:'Financial Structurt',
  Repaying:'Repaying',
},
  ...frLocale
}

export default fr